<div
    class="mx-auto flex max-w-screen-xl flex-col items-center justify-between md:flex-row">
    <div class="hidden flex-col justify-center md:order-1 md:flex">
        <p class="text-lg">
            From
            <span class="font-semibold text-red">{{
                itinerary?.startingPrice | currency: 'USD' : 'code' : '1.0-0'
            }}</span>
        </p>
        <p class="block text-sm text-deemphasized">per person</p>
    </div>
    <div
        class="grid w-full grid-cols-2 items-center justify-around space-x-2 px-4 text-sm md:order-3 md:w-auto md:justify-start md:space-x-4 md:px-0 md:text-base">
        <div>
            @if (!(isVisible | async)) {
                @if (
                    itinerary?.trip?.showGroupDepartures &&
                    (departures | async)?.length
                ) {
                    <button
                        class="mx-0 flex w-full justify-center gap-3 rounded-xl border border-lightgrey bg-white px-1 py-2 text-darkgrey duration-200 ease-in-out hover:bg-grey-150 md:w-auto md:px-6"
                        (click)="showDatesModal()">
                        <img
                            class="w-6"
                            src="/assets/images/navigation/dates_and_prices_icon.svg" />
                        {{
                            itinerary?.groupDepartureCtaText ||
                                itinerary?.trip?.groupDepartureCtaText ||
                                'Dates & Prices'
                        }}
                    </button>
                }
            }
        </div>
        <div>
            @if (itinerary?.trip?.showCustomDeparture) {
                <button
                    class="mx-0 flex w-full justify-center gap-3 rounded-xl border border-lightgrey bg-white px-1 py-2 text-darkgrey duration-200 ease-in-out hover:bg-grey-150 md:w-auto md:px-6"
                    (click)="showCustomModal()">
                    <img
                        class="w-6"
                        src="/assets/images/navigation/custom_trip_icon.svg" />
                    {{
                        itinerary?.customDepartureCtaText ||
                            itinerary?.trip?.customDepartureCtaText ||
                            'Propose Date'
                    }}
                </button>
            }
        </div>
    </div>
    <div class="hidden w-full md:order-3 md:block md:w-auto">
        <div
            class="flex items-center justify-between p-4 pt-6 md:hidden"
            (click)="toggleMenu($event, true)">
            <p>Jump to</p>
            <svg
                class="inline h-4 transform fill-current transition duration-500"
                [ngClass]="{ '-scale-y-100': menuOpen }"
                viewBox="0 0 20 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.666666 2.33333C0.666056 2.02179 0.774557 1.71988 0.973331 1.48C1.08526 1.34498 1.22273 1.23338 1.37786 1.15158C1.53299 1.06978 1.70273 1.01938 1.87737 1.00328C2.052 0.987179 2.2281 1.00569 2.39557 1.05775C2.56304 1.10981 2.7186 1.19439 2.85333 1.30666L10 7.28L17.16 1.52C17.2964 1.40924 17.4533 1.32653 17.6218 1.27662C17.7902 1.22672 17.9669 1.21059 18.1416 1.22918C18.3163 1.24776 18.4856 1.30069 18.6398 1.38492C18.794 1.46915 18.93 1.58303 19.04 1.72C19.1614 1.85795 19.2529 2.01951 19.3089 2.19452C19.3649 2.36954 19.3841 2.55424 19.3653 2.73703C19.3466 2.91982 19.2902 3.09676 19.1998 3.25673C19.1094 3.41671 18.9869 3.55627 18.84 3.66666L10.84 10.1067C10.6014 10.3028 10.3022 10.41 9.99333 10.41C9.6845 10.41 9.38524 10.3028 9.14666 10.1067L1.14667 3.44C0.985309 3.30624 0.857757 3.13633 0.774359 2.94405C0.69096 2.75177 0.654064 2.54254 0.666666 2.33333Z" />
            </svg>
        </div>
        <div
            class="flex flex-col items-center md:h-auto md:scale-y-100 md:flex-row md:gap-10"
            [ngClass]="menuOpen ? 'h-auto scale-y-100' : 'h-0 scale-y-0'">
            @for (menuItem of menuItems | async; track menuItem.title) {
                <div
                    class="relative w-full p-4 hover:cursor-pointer md:p-0 md:px-0 md:hover:border-mediumgrey"
                    [ngClass]="{
                        '!border-red text-red md:border-0 md:text-darkgrey':
                            menuItem === (activeMenuItem | async),
                    }"
                    (click)="navigate(menuItem)">
                    {{ menuItem.title }}
                    @if (menuItem === (activeMenuItem | async)) {
                        <div
                            class="absolute top-[2.8rem] hidden h-[3px] w-full bg-red md:block"></div>
                    }
                </div>
            }
        </div>
    </div>
</div>
